import strings from 'constants/index';
import { ColumnIds } from 'enums';

const defaultColumns = [
  { id: ColumnIds.Name, label: strings.name },
  { id: ColumnIds.LocalityName, label: strings.locality },
  { id: ColumnIds.GenderType, label: strings.gender },
];

const playerColumns = [
  { id: ColumnIds.Name, label: strings.name },
  { id: `person.${ColumnIds.LocalityName}`, label: strings.locality },
  { id: `person.${ColumnIds.GenderType}`, label: strings.gender },
];

const personColumns = [
  { id: ColumnIds.FullName, label: strings.full_name },
  { id: ColumnIds.LocalityName, label: strings.locality },
  { id: ColumnIds.GenderType, label: strings.gender },
];

const doublesColumns = [
  { id: ColumnIds.Name, label: strings.name },
  { id: ColumnIds.LocalityName, label: strings.locality },
  { id: ColumnIds.GenderType, label: strings.gender },
];

export const columnsByCompetitorTypeMapping = {
  Team: defaultColumns,
  Player: playerColumns,
  Double: defaultColumns,
  Person: personColumns,
  DoublesPartnership: doublesColumns,
};
//these columns are only for the case of Rounds, FIXT-5613, we call all season competitors instead of per competitorType
export const roundColumns = [
  { id: ColumnIds.Name, label: strings.name },
  { id: ColumnIds.LocalityName, label: strings.locality },
  { id: ColumnIds.GenderType, label: strings.gender },
];
